import * as React from "react";

import {
  Flex,
  Button,
  Image,
  Text,
  Stack,
  Box,
  Heading,
  SimpleGrid,
} from "@chakra-ui/react";

import { GiSpray } from "react-icons/gi";
import { FiChevronRight } from "react-icons/fi";

import products from "../products.js";

import { Link } from "gatsby";

const Accessories = (props) => {
  const displayAccessories = products
    .filter((product) => product.type === "doplnok")
    .slice(0, 4)
    .map((product) => (
      <Flex
        p={6}
        py={8}
        w="full%"
        border="1px"
        borderColor="blackAlpha.200"
        boxShadow={"lg"}
        _hover={{ boxShadow: "dark-lg", cursor: "pointer" }}
        rounded={"lg"}
        flexWrap="wrap"
        justify="center"
        transition="all 250ms"
        key={product.id}
      >
        <Link to={`/produkt/?id=${product.id}`}>
          <Image
            rounded={"lg"}
            height={60}
            width="100%"
            objectFit="contain"
            src={product.image}
          />
        </Link>

        <Link to={`/produkt/?id=${product.id}`}>
          <Box>
            <Stack pt={7} align={"center"}>
              <Text
                color={"black.500"}
                fontSize={"sm"}
                textTransform={"uppercase"}
                align="center"
              >
                {product.brand}
              </Text>
              <Heading
                fontSize={"2xl"}
                fontFamily={"body"}
                fontWeight={500}
                align="center"
              >
                {product.name}
              </Heading>
              <Stack direction={"row"} align={"center"}>
                <Text fontWeight={800} fontSize={"xl"}>
                  {product.price}€
                </Text>
                <Text textDecoration={"line-through"} color={"gray.600"}>
                  {props.formatter.format(product.price + product.price / 3)}€
                  9,42€
                </Text>
              </Stack>
            </Stack>
          </Box>
        </Link>
      </Flex>
    ));

  return (
    <>
      <Box
        px={{
          base: "24px",
          md: "48px",
          lg: "96px",
          "2xl": "256px",
        }}
        bg="white"
        transition="all 250ms"
        py={{ base: 12, md: 24 }}
      >
        <Flex
          align={{ base: "start", sm: "center" }}
          width="100%"
          borderBottom="1px"
          borderColor="blackAlpha.300"
          pb={6}
          flexWrap="wrap"
          justify="space-between"
          color="black.900"
          flexDirection={{ base: "column", sm: "row" }}
        >
          <Flex justify="start" align="center">
            <Box fontSize="4xl" mr={3} color="red.500">
              <GiSpray />
            </Box>
            <Heading as="h1">Autodoplnky</Heading>
          </Flex>

          <Flex
            justify="start"
            align={{ base: "flex-start", sm: "flex-end" }}
            flexWrap="wrap"
            flexDirection={{ base: "column", sm: "row" }}
            mt={{ base: 5, md: 3 }}
          >
            <Link to="/doplnky/?subCategory=elektronika">
              <Button
                variant="ghost"
                _focus={{ outlineColor: "red.500" }}
                _hover={{ backgroundColor: "red.50" }}
                _active={{ backgroundColor: "red.50" }}
              >
                Elektronika
              </Button>
            </Link>

            <Link to="/doplnky/?subCategory=interier">
              <Button
                variant="ghost"
                _focus={{ outlineColor: "red.500" }}
                _hover={{ backgroundColor: "red.50" }}
                _active={{ backgroundColor: "red.50" }}
              >
                Interiér
              </Button>
            </Link>

            <Link to="/doplnky/?subCategory=exterier">
              <Button
                variant="ghost"
                _focus={{ outlineColor: "red.500" }}
                _hover={{ backgroundColor: "red.50" }}
                _active={{ backgroundColor: "red.50" }}
              >
                Exteriér
              </Button>
            </Link>

            <Link to="/doplnky/?subCategory=cistenie">
              <Button
                variant="ghost"
                _focus={{ outlineColor: "red.500" }}
                _hover={{ backgroundColor: "red.50" }}
                _active={{ backgroundColor: "red.50" }}
              >
                Čistenie a starostlivosť
              </Button>
            </Link>

            <Link to="/doplnky/?subCategory=bezpecnost">
              <Button
                variant="ghost"
                _focus={{ outlineColor: "red.500" }}
                _hover={{ backgroundColor: "red.50" }}
                _active={{ backgroundColor: "red.50" }}
              >
                Bezpečnosť
              </Button>
            </Link>

            <Link to="/doplnky">
              <Button
                variant="ghost"
                color="red.500"
                _focus={{ outlineColor: "red.500" }}
                _hover={{ backgroundColor: "red.50" }}
                _active={{ backgroundColor: "red.50" }}
                rightIcon={<FiChevronRight />}
              >
                Ďalšie
              </Button>
            </Link>
          </Flex>
        </Flex>

        <SimpleGrid
          columns={{ base: "1", sm: "2", lg: "4" }}
          spacing={4}
          mt={8}
        >
          {displayAccessories}
        </SimpleGrid>
      </Box>
    </>
  );
};

export default Accessories;
